import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../Firebase";

import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";

import MDBox from "components/MDBox";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import TwitterIcon from "@mui/icons-material/Twitter";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import TelegramIcon from "@mui/icons-material/Telegram";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import Footer from "examples/Footer";

function Dashboard() {
  const [users, setUsers] = useState([]);
  const [achievers, setAchievers] = useState([]);
  const [blogs, setBlogs] = useState([]);

  const [copySuccess, setCopySuccess] = useState({
    facebook: false,
    instagram: false,
    youtube: false,
    twitter: false,
    whatsapp: false,
    telegram: false,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [usersSnapshot, achieversSnapshot, blogsSnapshot] = await Promise.all([
          getDocs(collection(db, "users")),
          getDocs(collection(db, "achievers")),
          getDocs(collection(db, "blogs")),
        ]);

        setUsers(usersSnapshot.docs.map((doc) => doc.data()));
        setAchievers(achieversSnapshot.docs.map((doc) => doc.data()));
        setBlogs(blogsSnapshot.docs.map((doc) => doc.data()));
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    };

    fetchData();
  }, []);

  const copyToClipboard = (url, platform) => {
    navigator.clipboard
      .writeText(url)
      .then(() => {
        setCopySuccess((prev) => ({ ...prev, [platform]: true }));
        setTimeout(() => setCopySuccess((prev) => ({ ...prev, [platform]: false })), 2000);
      })
      .catch(() => {
        setCopySuccess((prev) => ({ ...prev, [platform]: false }));
      });
  };

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox py={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="info"
                  icon="group"
                  title="Total Users"
                  count={users.length}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="secondary"
                  icon="emoji_events"
                  title="Total Achievers"
                  count={achievers.length}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="warning"
                  icon="article"
                  title="Total Blogs"
                  count={blogs.length}
                />
              </MDBox>
            </Grid>
          </Grid>

          <MDBox mt={5}>
            <h2 style={{ fontSize: "1.5rem", fontWeight: "600", marginBottom: "1rem" }}>
              Our Social Medias :
            </h2>
            <Grid container spacing={2}>
              {[
                {
                  name: "facebook",
                  icon: <FacebookIcon fontSize="large" sx={{ color: "#1877F2" }} />,
                  url: "https://www.facebook.com/profile.php?id=61570826912508",
                },
                {
                  name: "instagram",
                  icon: <InstagramIcon fontSize="large" sx={{ color: "#d62976" }} />,
                  url: "https://www.instagram.com/nityamala_51?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
                },
                {
                  name: "youtube",
                  icon: <YouTubeIcon fontSize="large" sx={{ color: "#FF0000" }} />,
                  url: "https://youtube.com/@nityamala?si=aPVdgzgspapoDRTc",
                },
                {
                  name: "twitter",
                  icon: <TwitterIcon fontSize="large" sx={{ color: "#1DA1F2" }} />,
                  url: "https://www.threads.net/@nityamala_51",
                },
                {
                  name: "whatsapp",
                  icon: <WhatsAppIcon fontSize="large" sx={{ color: "#25D366" }} />,
                  url: "https://wa.me/11234567890",
                },
                {
                  name: "telegram",
                  icon: <TelegramIcon fontSize="large" sx={{ color: "#0088cc" }} />,
                  url: "https://t.me/yourusername",
                },
              ].map((platform, idx) => (
                <Grid item xs={4} sm={2} md={2} lg={1} key={idx}>
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <a href={platform.url} target="_blank" rel="noreferrer">
                      {platform.icon}
                    </a>
                    <Button
                      onClick={() => copyToClipboard(platform.url, platform.name)}
                      sx={{ minWidth: "auto", padding: "0", color: "gray" }}
                    >
                      {copySuccess[platform.name] ? (
                        <CheckCircleIcon fontSize="small" color="success" />
                      ) : (
                        <ContentCopyIcon fontSize="small" />
                      )}
                    </Button>
                  </div>
                </Grid>
              ))}
            </Grid>
          </MDBox>
        </MDBox>
        {/* <Footer /> */}
      </DashboardLayout>
    </>
  );
}

export default Dashboard;
